module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding_comp auth-input-page"
  }, [_c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Age group")]), _vm._v(" "), _c('div', {
    staticClass: "selections"
  }, _vm._l((_vm.ageGroups), function(age, index) {
    return _c('div', {
      key: index,
      staticClass: "selection",
      class: {
        _selected: _vm.ageRange == age.title
      },
      on: {
        "click": function($event) {
          _vm.selectAgeRange(age)
        }
      }
    }, [_vm._v("\n        " + _vm._s(age.title) + "\n      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group mb-2"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    class: {
      _filled: _vm.country
    },
    attrs: {
      "type": "text",
      "placeholder": "Type your country"
    },
    domProps: {
      "value": (_vm.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.country = $event.target.value
      }
    }
  }), _vm._v(" "), _c('autocomplete', {
    staticClass: "location",
    attrs: {
      "keyword": _vm.country,
      "options": _vm.getCountryList,
      "identifier": "country"
    },
    on: {
      "selected": _vm.selected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    class: {
      _filled: _vm.city
    },
    attrs: {
      "type": "text",
      "placeholder": "Type your city"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('autocomplete', {
    staticClass: "location",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "keyword": _vm.city,
      "options": _vm.getCityList,
      "identifier": "city"
    },
    on: {
      "selected": _vm.selected
    }
  })], 1), _vm._v(" "), _c('VueLoadingButton', {
    staticClass: "w-100",
    attrs: {
      "loading": _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }, [_c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n        Back\n      ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n        Next\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9a364b6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/ageLocation.vue
// module id = 1876
// module chunks = 180